import { gql } from '@apollo/client';

const updateUser = gql`
  mutation ($variables: UpdateUser, $username: String!) {
    updateUser(input: $variables, username: $username) {
      user {
        username
        email
        enabled
        roles
        last_login
        avatar
        avatar_config
      }
      token
    }
  }
`;

export default updateUser;
